import React, { FC, useEffect, useState } from 'react'
import { IonModal, IonHeader, IonFooter, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { restaurantCenter, restaurantConfig } from 'restaurant'
import { MktButton } from '@cps'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  type: string;
  selected: boolean;
}

const ModeStyle: FC<IProps> = (props) => {
  const { type, selected } = props
  return (
    <div className={`mode-style ${selected && 'selected'}`}>
      {
        type === 'list' &&
          <div className='list'>
            <div className='list-item'>
              <div className='cate-item'></div>
              <div className='list-item-r'>
                <div className='pro-item'></div>
                <div className='pro-item short'></div>
              </div>
            </div>
            <div className='list-item'>
              <div className='cate-item'></div>
              <div className='list-item-r'>
                <div className='pro-item'></div>
                <div className='pro-item short'></div>
              </div>
            </div>
            <div className='list-item'>
              <div className='cate-item'></div>
              <div className='list-item-r'>
                <div className='pro-item'></div>
                <div className='pro-item short'></div>
              </div>
            </div>
            <div className='list-item'>
              <div className='cate-item'></div>
              <div className='list-item-r'>
                <div className='pro-item'></div>
                <div className='pro-item short'></div>
              </div>
            </div>
          </div>
      }
      {
        type === 'classic' &&
          <div className='classic'>
            <div className='classic-l'>
              <div className='cate-item'></div>
              <div className='pro-item short'></div>
              <div className='pro-item short'></div>
              <div className='pro-item short'></div>
            </div>
            <div className='classic-r'>
              <div className='list-item'>
                <div className='cate-item'></div>
                <div className='list-item-r'>
                  <div className='pro-item middle'></div>
                  <div className='pro-item short'></div>
                </div>
              </div>
              <div className='list-item'>
                <div className='cate-item'></div>
                <div className='list-item-r'>
                  <div className='pro-item middle'></div>
                  <div className='pro-item short'></div>
                </div>
              </div>
              <div className='list-item'>
                <div className='cate-item'></div>
                <div className='list-item-r'>
                  <div className='pro-item middle'></div>
                  <div className='pro-item short'></div>
                </div>
              </div>
              <div className='list-item'>
                <div className='cate-item'></div>
                <div className='list-item-r'>
                  <div className='pro-item middle'></div>
                  <div className='pro-item short'></div>
                </div>
              </div>
            </div>
          </div>
      }
      {
        type === 'waterfall' &&
          <div className='waterfall'>
            <div>
              <div className='cate-item'></div>
              <div className='pro-item'></div>
              <div className='pro-item short margin'></div>
              <div className='cate-item'></div>
              <div className='pro-item'></div>
              <div className='pro-item short margin'></div>
              <div className='cate-item middle'></div>
            </div>
            <div>
              <div className='cate-item'></div>
              <div className='pro-item margin'></div>
              <div className='cate-item big'></div>
              <div className='pro-item margin'></div>
              <div className='cate-item small'></div>
            </div>
          </div>
      }
    </div>
  )
}

export default observer(ModeStyle)
